module.exports = __webpack_public_path__ + "img/jobs2.0f8608ad.svg";